module.exports = __webpack_public_path__ + "static/media/hall.fd7e1a78.jpg";